export default "__VITE_ASSET__zIsla8L8__"